import { AccessTime, ContactPhone, ContactMail } from '@mui/icons-material';
import { Grid, Card, CardContent, Typography, Badge, Link } from '@mui/material';
import { useMyIntl } from 'my-intl';

import { styles } from './constants';

import './contact-details.scss';

function ContactDetails() {
  const { translateMessage } = useMyIntl();

  const secondaryTexColortWithBottomMargin = { color: 'text.secondary', mb: 1.5 };
  const secondaryTextColor = { color: 'text.secondary', mb: 0 };
  const fontSIze = '0.75rem';

  return (
    <Grid container spacing={2} className={'contactDetails'}>
      <Grid size={{ xs: 8, md: 4 }} className={'contactItem'}>
        <Card>
          <CardContent>
            <Typography component="div" variant="h5" display={'flex'} alignItems={'center'} marginBottom={'1.5rem'}>
              <Badge color="primary">
                <AccessTime />
              </Badge>
              &nbsp;{translateMessage('shchedule.title')}
            </Typography>
            <Typography component="div" fontSize={fontSIze}>
              <Typography sx={secondaryTexColortWithBottomMargin}>
                {translateMessage('shchedule.time.tuesday')}
              </Typography>
              <Typography component="div" sx={secondaryTexColortWithBottomMargin}>
                {translateMessage('shchedule.time.thursday')}
              </Typography>
              <Typography sx={secondaryTextColor}>{translateMessage('shchedule.time.saturday')}</Typography>
            </Typography>
          </CardContent>
        </Card>
      </Grid>
      <Grid size={{ xs: 8, md: 4 }} className={'contactItem'}>
        <Card>
          <CardContent>
            <Typography component="div" variant="h5" display={'flex'} alignItems={'center'} marginBottom={'1.5rem'}>
              <Badge color="primary">
                <ContactPhone />
              </Badge>
              &nbsp;{translateMessage('shchedule.callUsTitle')}
            </Typography>
            <Typography component="div" fontSize={fontSIze}>
              <Typography sx={secondaryTexColortWithBottomMargin}>{translateMessage('contacts.mobile.dp')}</Typography>
              <Typography component="div" sx={secondaryTexColortWithBottomMargin}>
                {translateMessage('contacts.mobile.vm')}
              </Typography>
              <Typography sx={secondaryTextColor}>&nbsp;</Typography>
            </Typography>
          </CardContent>
        </Card>
      </Grid>
      <Grid size={{ xs: 8, md: 4 }} className={'contactItem'}>
        <Card>
          <CardContent>
            <Typography component="div" variant="h5" display={'flex'} alignItems={'center'} marginBottom={'1.5rem'}>
              <Badge color="primary">
                <ContactMail />
              </Badge>
              &nbsp;{translateMessage('shchedule.emailUsTitle')}
            </Typography>
            <Typography component="div" fontSize={fontSIze}>
              <Typography component="div" sx={{ color: styles.link.color.primary, mb: 1.5 }}>
                <Link href={`mailto:${translateMessage('contacts.email')}`}>{translateMessage('contacts.email')}</Link>
              </Typography>
              <Typography component="div" sx={secondaryTexColortWithBottomMargin}>
                &nbsp;
              </Typography>
              <Typography component="div" sx={secondaryTextColor}>
                &nbsp;
              </Typography>
            </Typography>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
}

export default ContactDetails;
